"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GridColumns = exports.Column = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledSystem = require("styled-system");

var _Box = require("../Box");

var _CSSGrid = require("../CSSGrid");

var _calculateGridColumn = require("./calculateGridColumn");

var _excluded = ["span", "start", "wrap"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * A 12-column fluid grid
 */
var GridColumns = (0, _styledComponents.default)(_CSSGrid.CSSGrid).withConfig({
  displayName: "GridColumns",
  componentId: "sc-1g9p6xx-0"
})(["grid-template-columns:repeat(12,1fr);"]);
exports.GridColumns = GridColumns;
GridColumns.defaultProps = {
  gridColumnGap: [1, 2],
  gridRowGap: [1, 2]
};
var Cell = (0, _styledComponents.default)(_Box.Box).withConfig({
  displayName: "GridColumns__Cell",
  componentId: "sc-1g9p6xx-1"
})(["", ""], _styledSystem.gridColumn);
/** Column implements `Box` and `gridColumn` */

/**
 * A column sits within the GridColumns and spans the columns,
 * sitting between gutters.
 */
var Column = function Column(_ref) {
  var span = _ref.span,
      start = _ref.start,
      wrap = _ref.wrap,
      rest = _objectWithoutProperties(_ref, _excluded);

  var gridColumnValue = (0, _react.useMemo)(function () {
    return (0, _calculateGridColumn.calculateGridColumn)({
      span: span,
      start: start
    });
  }, [span, start]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(Cell, _extends({
    gridColumn: gridColumnValue
  }, rest)), wrap && /*#__PURE__*/_react.default.createElement(ColumnWrap, {
    gridColumnValue: gridColumnValue
  }));
};

exports.Column = Column;

var ColumnWrap = function ColumnWrap(_ref2) {
  var gridColumnValue = _ref2.gridColumnValue;
  return /*#__PURE__*/_react.default.createElement(Cell // Spans the remainder of the columns until the end
  , {
    gridColumn: ["auto / -1"] // Hides the break if the value presented is going to span the full
    // width of the column anyway. Prevents duplicated row gaps.
    ,
    display: gridColumnValue.map(function (value) {
      return _calculateGridColumn.GRID_COLUMN_FULL_WIDTHS.includes(value) ? "none" : "block";
    })
  });
};

ColumnWrap.displayName = "ColumnWrap";
//# sourceMappingURL=GridColumns.js.map